import Swal from 'sweetalert2'
import {useAuth} from '../../../../app/modules/auth'
import {Header} from './components/header/Header'
import {InvoiceModal} from './components/modal/InvoiceModal'
import {downloadFilePDF} from './core/_requests'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider, useQueryResponseLoading} from './core/QueryResponseProvider'
import {FilterProvider} from './FilterProvider'
import {Table} from './table/Table'
import {useEffect} from 'react'
import {InvoiceLogModal} from './components/modal/InvoiceLogModal'
import {InvoicePaymentLogModal} from './components/modal/InvoicePaymentLogModal'

const List = () => {
  const {
    itemIdForUpdate,
    itemIdForUpdateLog,
    itemIdForUpdatePdf,
    setItemIdForUpdatePdf,
    paymentLog,
  } = useListView()
  const isLoading = useQueryResponseLoading()
  const {currentFranchise} = useAuth()

  useEffect(() => {
    const generatePdf = async () => {
      if (!itemIdForUpdatePdf) return

      try {
        Swal.fire({
          icon: 'info',
          title: 'Relatório em processamento',
          showConfirmButton: false,
          allowOutsideClick: false,
        })

        await downloadFilePDF(itemIdForUpdatePdf, currentFranchise?.id || 0)
      } catch (error: any) {
        await Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: error.message,
          confirmButtonColor: '#d33',
        })
      } finally {
        setItemIdForUpdatePdf?.(undefined)
        Swal.close()
      }
    }
    generatePdf()
  }, [itemIdForUpdatePdf])

  return (
    <>
      {isLoading}
      <Header />
      <Table />
      {itemIdForUpdate && (
        <InvoiceModal invoiceId={itemIdForUpdate} franchiseId={currentFranchise?.id || 0} />
      )}
      {itemIdForUpdateLog && <InvoiceLogModal invoiceId={itemIdForUpdateLog} />}
      {paymentLog && <InvoicePaymentLogModal dataPaymentLog={paymentLog} />}
    </>
  )
}

const InvoiceHistoryListPage = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <FilterProvider>
          <List />
        </FilterProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export default InvoiceHistoryListPage
